import axios from "axios";

export const getPendingCompanies = async () => {
  const url = window.location.hostname.includes('localhost')  ? 'localhost' : 'unioninformatica.org';

  const config = {
    method: "GET",
    url: `http://${url}:4000/api/v1/boletaDigital/getPendingCompanies`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    return await axios(config);
  } catch (error) {
    const { response } = error;
    return await response;
  }
};
